import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    isAuthLoading: true,
    user: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserDetail: (state, action) => {
            state.isAuthenticated = true;
            state.isAuthLoading = false;
            state.user = {
                email: action.payload.email,
                firstName: action.payload.given_name || action.payload.firstName,
                lastName: action.payload.family_name || action.payload.lastName,
                companyId: action.payload.companyId,
                companyName: action.payload.companyName,
                phoneNumber: action.payload.phoneNumber,
                phoneNumberVerified: action.payload.phoneNumberVerified,
                userId: action.payload.userId,
                tokens: action.payload.tokens
            };
        },
        // updateUserDetail: (state, action) => {
        //     state.user = { ...state.user, ...action.payload };
        // },
        clearUserDetail: (state) => {
            state.isAuthenticated = false;
            state.isAuthLoading = false;
            state.user = null;
        },
        setAuthLoading: (state, action) => {
            state.isAuthLoading = action.payload;
        },
    },
});

export const { setUserDetail, clearUserDetail, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;
